<template>
  <div>
    <div>
      <v-layout wrap >
        <v-flex xs9 class="partner-logo pl-2" style="display: flex;align-items: center;">
          <h3 class="headline mt-0" style="display:table;">
              <img src="/static/img/logo_line_my_shop.png" alt style="max-height: 22px" />
              <a style="margin: -4px 5px;"
                href="https://blog.zwiz.app/lineshopping/"
                target="blank"
                ><i
                  style="font-size: 20px; color: #ed1e79;"
                  class="fas fa-question-circle"
                ></i
              ></a>
          </h3>
        </v-flex>
        <v-flex class="text-xs-right">
          <template v-if="check_privilege('sokochan')">
            <v-btn class="partner-logo" fab outline small color="primary" v-if="!isEdit" @click="isEdit = true">
              <v-icon>edit</v-icon>
            </v-btn>
          </template>
          <template v-else>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn readonly fab outline small color="grey" v-on="on">
                  <v-icon>lock</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('Upgrade to {package} Plan', { package: $t('PREMIUM') }) }}</span>
            </v-tooltip>
          </template>
        </v-flex>
      </v-layout>
      <div v-if="loading" class="text-xs-center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <div v-else>
        <v-stepper v-model="step" vertical class="elevation-0">
          <v-stepper-step step="1" :complete="step > 1">
            {{ $t('register_line_shopping') }}
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-premium-plan-popup2
              v-if="!getPackageType().includes('advanced')"
              type="advanced"
              text="This function is only available for the Advanced Package. Starting at 990 baht / month ,click to upgrade."
            ></v-premium-plan-popup2>
            <!-- <div>เชื่อมต่อ LINE SHOPPING</div> -->
            <v-btn
              depressed
              color="primary"
              :href="'https://lineshoppingseller.com/'"
              target="_blank"
            >
              {{ $t('register_line_shopping') }}</v-btn
            >
            <v-btn flat @click="step = 2">
              {{ $t('already_have_an_account') }}
            </v-btn>
            <div>
              <a href="javascript:void(0)" @click="dialogLineMyShop = true">{{
                $t('line_shop_dialog')
              }}</a>
            </div>
            <v-dialog v-model="dialogLineMyShop" persistent width="700">
              <v-card>
                <v-card-text>
                  <v-layout>
                    <v-flex>
                      <h3 class="mb-4">{{ $t('line_shop_dialog1') }}</h3>
                    </v-flex>
                    <v-flex class="text-xs-right">
                      <v-btn fab small flat @click="dialogLineMyShop = false">
                        <v-icon>close</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <p>
                    {{ $t('line_shop_dialog2') }}
                    <v-btn
                      depressed
                      color="primary"
                      :href="'https://lineshoppingseller.com/'"
                      target="_blank"
                      >{{ $t('fill_in_form') }}</v-btn
                    >
                  </p>
                  <p>
                    {{ $t('line_shop_dialog3') }}
                  </p>
                  <p>
                    {{ $t('line_shop_dialog4') }}
                  </p>
                  <p>
                    {{ $t('line_shop_dialog5') }}
                  </p>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-stepper-content>
          <v-stepper-step step="2" :complete="step > 2">
            <div style="display: block;">
              {{ $t('connect_zwiz_with_line_shopping') }}
              <v-btn
                color="grey"
                outline
                @click="step = 1"
                v-if="showCancel && step === 2 && isEdit"
                :loading="loading"
              >
                {{ $t('Back') }}
              </v-btn>
            </div>
          </v-stepper-step>
          <v-stepper-content step="2">
            <div
              style="position: relative; "
              :style="{ 'min-height': !check_privilege('sokochan') ? '300px' : '' }"
            >
              <template v-if="isEdit" class="form-control">
                <div class="caption">api_key</div>
                <div class="form-control" :class="{ 'has-error': errors.has('api_key') }">
                 
                    <input
                      type="text"
                      class="form-control"
                      v-model="setting.api_key"
                      v-validate="'required'"
                      name="setting.api_key"
                      data-vv-as="api_key"
                    />
                    <span class="text-error" v-if="errors.has('setting.api_key')">{{
                      errors.first('setting.api_key')
                    }}</span>
                  
                </div>
                <div class="caption">shop_url</div>
                <div class="form-control" :class="{ 'has-error': errors.has('shop_url') }">
                  <template>
                    <input
                      type="text"
                      v-model="setting.shop_url"
                      v-validate="'required'"
                      name="setting.shop_url"
                      data-vv-as="shop_url"
                    />
                    <span class="text-error" v-if="errors.has('setting.shop_url')">{{
                      errors.first('setting.shop_url')
                    }}</span>
                  </template>
                </div>
                <div class="caption">liff_shop_url</div>
                <div class="form-control" :class="{ 'has-error': errors.has('liff_shop_url') }">
                  <template>
                    <input
                      type="text"
                      v-model="setting.liff_shop_url"
                      v-validate="'required'"
                      name="setting.liff_shop_url"
                      data-vv-as="liff_shop_url"
                    />
                    <span class="text-error" v-if="errors.has('setting.liff_shop_url')">{{
                      errors.first('setting.liff_shop_url')
                    }}</span>
                  </template>
                </div>
              </template>
              <template v-else>
                <div class="caption">api_key</div>
                <div v-if="!loading" class="primary--text">
                  {{ setting.api_key ? setting.api_key : '-' }}
                </div>
                <div class="caption">shop_url</div>
                <div v-if="!loading" class="primary--text">
                  {{ setting.shop_url ? setting.shop_url : '-' }}
                </div>
                <div class="caption">liff_shop_url</div>
                <div v-if="!loading" class="primary--text">
                  {{ setting.liff_shop_url ? setting.liff_shop_url : '-' }}
                </div>
              </template>
              <div class="mb-2 mt-2" v-if="showCancel">
                <div>
                  {{ $t('enable_disable_line') }}
                </div>
                <div>
                  <toggle-button
                    class="mt-2"
                    :value="setting.is_active"
                    :sync="true"
                    :color="$vuetify.theme.success"
                    @change="toggleStatus"
                    :labels="{ checked: 'ON', unchecked: 'OFF' }"
                    style="display: inline-block"
                  />
                </div>
              </div>
              <div class="text-xs-center" v-if="isEdit">
                <v-btn
                  color="grey"
                  outline
                  @click="isEdit = false"
                  v-if="showCancel"
                  :loading="loading"
                >
                  {{ $t('cancel') }}
                </v-btn>
                <v-btn color="primary" depressed @click="onSave" :loading="loading">
                  {{ $t('Save') }}
                </v-btn>
              </div>
            </div>
          </v-stepper-content>
        </v-stepper>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import { cloneDeep } from 'lodash'
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  components: {
    ToggleButton
  },
  data() {
    return {
      dialogLineMyShop: false,
      isEdit: false,
      loading: false,
      zortoutToken: null,
      setting: {
        is_active: false,
        liff_shop_url: null,
        api_key: null,
        shop_url: null
      },
      showCancel: true,
      step: 1
    }
  },
  async mounted() {
    this.getLineMyShopConfig()
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  methods: {
    async getLineMyShopConfig() {
      const data = {
        pageId: this.selectedBot.pageid
      }
      let response = await api.getLineMyShopConfig(data)
      if (response && response.success) {
        console.log(response)
        this.setting.api_key = response.result.api_key
        this.setting.shop_url = response.result.shop_url
        this.setting.liff_shop_url = response.result.liff_shop_url
        this.setting.is_active = response.result.is_active
      }
      if (response && response.result && response.result.liff_shop_url && response.result.api_key) {
        this.step = 2
      }
    },
    async putLineMyShopConfig(setting) {
      this.$store.dispatch('loading')
      const data = {
        pageId: this.selectedBot.pageid,
        body: setting
      }
      let response = await api.putLineMyShopConfig(data)
      console.log(response)
      if (response.result) {
        this.isEdit = false
      } else {
        this.setting.is_active = !this.setting.is_active
      }
      this.$store.dispatch('loading')
    },
    onSave() {
      this.putLineMyShopConfig(this.setting)
    },
    async toggleStatus() {
      this.setting.is_active = !this.setting.is_active
      this.putLineMyShopConfig(this.setting)
    }
  }
}
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 600px){
  .v-stepper__content{
    margin:0 !important;
    padding:0 !important
  }

}  
</style>



// WEBPACK FOOTER //
// src/components/view/billing/LineMyShopManage.vue